import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import ChartConfig, { tooltipStyle } from 'Constants/chart-config';

import {  
  mskVisualisationDetails
} from 'Actions';

class ShoulderChartComponent extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  render() {

    const { visualisationdetails, loading} = this.props;
    let shoulderlist= visualisationdetails.Shoulder; 
    
    const data=shoulderlist.map((assmntval,idx) => {  
          return {
              
              name: assmntval.assessment,
              RightIR: assmntval.rightshoulderIR,
              LeftIR: assmntval.leftshoulderIR,
              RightER: assmntval.rightshoulderER,
              LeftER : assmntval.leftshoulderER,
          }
    }); 
    return (
     

      <ResponsiveContainer width={this.props.data} height={400}>         
      <BarChart data={data}>
        <XAxis dataKey="name" stroke={ChartConfig.axesColor} />
        <YAxis stroke={ChartConfig.axesColor} domain={[0, 'dataMax + 5']} />
        <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
        <Tooltip wrapperStyle={tooltipStyle} cursor={false} />
        <Legend />
          <Bar dataKey="RightIR" name="Right Shoulder IR" fill={ChartConfig.color.rightshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="LeftIR" name="Left Shoulder IR" fill={ChartConfig.color.leftshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="RightER" name="Right Shoulder ER" fill={ChartConfig.color.rightshER} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="LeftER" name="Left Shoulder ER"  fill={ChartConfig.color.leftshER} label={{ position: "top" }} barSize={20}/>        
      </BarChart>
      </ResponsiveContainer>
     
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails
})(ShoulderChartComponent); 